import {ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';
import {Router} from "@angular/router";
import {AuthService} from '../../shared-component/service/auth/auth.service';
import {LoanService} from '../../shared-component/service/loan/loan.service';
import {CustomerService} from '../../shared-component/service/customer/customer.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'ap-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};
  public profiledata: any = {};
  public userImage: any = null;
  public elem;
  public isFullscreenActive = false;
  
  @Output() myEvent = new EventEmitter();

  constructor(
    private router: Router,
    private auth: AuthService,
    private loanService: LoanService,
    private customerService: CustomerService,
    @Inject(DOCUMENT) private document: any,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.loanService.profile().subscribe((res: any) => {
      this.profiledata = res.data;
        this.customerService.getIdProofPathS3Customer(this.profiledata.id).subscribe((res: any) => {
          this.userImage = res.data.signed.signUpPhotoPath;
        });
    });
    this.elem = document.documentElement;
    document.addEventListener('fullscreenchange', () => this.checkFullScreenStatus());
    document.addEventListener('mozfullscreenchange', () => this.checkFullScreenStatus());
    document.addEventListener('webkitfullscreenchange', () => this.checkFullScreenStatus());
    document.addEventListener('msfullscreenchange', () => this.checkFullScreenStatus());
    this.checkFullScreenStatus();
  }

  logout() {
    this.auth.logout(sessionStorage.getItem('customer_token')).subscribe(() => {
      sessionStorage.removeItem('customer_token');
      this.router.navigate(['/authentication']);
    });
  }

  goToProfile() {
    this.router.navigate(['/profile']);
  }

  toggleSidebar() {
    this.myEvent.emit();
  }

  checkFullScreenStatus() {
    if (document.fullscreenElement) {
      this.isFullscreenActive = true;
    } else {
      this.isFullscreenActive = false;
    }
  }

  openFullscreen() {
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }

  /* Close fullscreen */
  closeFullscreen() {
    if (document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      /* Firefox */
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      /* IE/Edge */
      this.document.msExitFullscreen();
    }
  }

}
